<app-poi-sync [id]="vehicle.id" *ngIf="vehicle" type="vehicles"></app-poi-sync>
